import { validateProcedure } from './procedureValidator';
import { failedOutcome, resolveFood } from './outcome';
import type { FoodInput, FoodTestOutcome, ProcedureState } from './types';

export function getIodineOutcome(food: FoodInput, procedure: ProcedureState): FoodTestOutcome {
  const validation = validateProcedure('starch', procedure);
  if (!validation.valid) return failedOutcome('starch', validation.errors.join(' '));
  const sample = resolveFood(food);
  const positive = sample.composition.starch >= 0.15;
  return {
    test: 'starch',
    category: positive ? (sample.composition.starch >= 0.65 ? 'strong-positive' : 'positive') : 'negative',
    observation: positive ? 'The iodine changes from yellow-brown to blue-black, indicating starch.' : 'The iodine remains yellow-brown; starch is not detected.',
    colour: positive ? '#142c65' : '#a97820',
    colourName: positive ? 'blue-black' : 'yellow-brown',
    precipitate: false,
    emulsion: false,
    reasoning: 'Iodine forms a blue-black complex with starch. This test is performed at room temperature.',
    warnings: validation.warnings,
  };
}